<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header
          v-if="!everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon class="load-rotate">hourglass_empty</md-icon>
          </div>
          <h4 class="title">Laden</h4>
        </md-card-header>
        <md-card-header
          v-if="everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>schedule</md-icon>
          </div>
          <h4 class="title">Overzicht van ingeplande diensten per chauffeur</h4>
        </md-card-header>
        <md-card-content>
          <md-table
            v-if="everythingLoaded"
            :value="queriedData"
            class="table-striped table-hover"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Chauffeurs per pagina</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="(item, itemIndex) in pagination.perPageOptions"
                    :key="'page' + itemIndex"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Zoek Chauffeurs(s)"
                  v-model="searchQuery"
                >
                </md-input>
              </md-field>
              <md-checkbox v-if="everythingLoaded" v-model="excludeInactive"
                >Verberg inactieve chauffeurs</md-checkbox
              >
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Status">
                <inline-badge
                  :value="getStatusLabel(item.deleted)"
                  :bg-color="getStatusColor(item.deleted)"
                />
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEditDriver(item)"
                md-label="Naam"
              >
                {{ item.name }}
              </md-table-cell>
              <md-table-cell
                v-for="weekIndex in allWeeksReverseOrder()"
                :key="item.id + weekIndex"
                :md-label="'Week ' + weekIndex"
              >
                <inline-badge
                  v-for="(routeCount, routeId) in item.routes[weekIndex]"
                  :key="item.id + weekIndex + routeId"
                  :value="routeCount"
                  :bg-color="getRouteColor(routeId)"
                />
                <inline-badge
                  v-for="(unavailable, unavailableId) in item.unavailable[
                    weekIndex
                  ]"
                  :key="item.id + weekIndex + unavailableId"
                  :value="unavailable"
                  bg-color="#f44336"
                />
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions v-if="everythingLoaded" md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Weergave van {{ from + 1 }} t/m {{ to }} van
              {{ total }} chauffeurs
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>

      <ul class="legend" v-if="everythingLoaded">
        <li><h5>Legenda</h5></li>
        <li
          v-for="(route, routeIndex) in this.routes"
          :key="'legend' + routeIndex"
        >
          <inline-badge
            :value="routeIndex + 2"
            :bg-color="getRouteColor(route.id)"
          />
          {{ routeIndex + 2 }} ingeplande diensten bij {{ route.name }}
        </li>
        <li>
          <inline-badge value="Di-Do" bg-color="#f44336" />
          Dinsdag t/m donderdag niet beschikbaar
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import InlineBadge from "./InlineBadge";

export default {
  components: {
    Pagination,
    InlineBadge,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableDataFiltered;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDataFiltered.length;
    },
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    tableDataComputed: function() {
      let data = [];
      for (let i in this.tableData) {
        let row = this.tableData[i];

        row["name"] = this.getFullName(this.tableData[i]);
        row["sort"] = this.getFullNameSort(this.tableData[i]);
        row["routes"] = {};
        row["unavailable"] = {};

        for (let year in this.report) {
          for (let week in this.report[year]) {
            row["routes"][week] = {};
            if (this.report[year][week].hasOwnProperty(row["id"]) === false) {
              continue;
            }
            for (let routeItemKey in this.report[year][week][row["id"]][
              "routes"
            ]) {
              let routeItem = this.report[year][week][row["id"]]["routes"][
                routeItemKey
              ];
              if (
                row["routes"][week].hasOwnProperty(routeItem["route_id"]) ===
                false
              ) {
                row["routes"][week][routeItem["route_id"]] = 0;
              }
              row["routes"][week][routeItem["route_id"]] += routeItem["count"];
            }

            // unavailable periods
            row["unavailable"][week] = [];
            if (
              this.report[year][week][row["id"]]["unavailable"].length === 0
            ) {
              continue;
            }

            let firstDay = 0;
            let lastDay = 0;
            for (let unavailableItemKey in this.report[year][week][row["id"]][
              "unavailable"
            ]) {
              if (firstDay === 0) {
                firstDay = unavailableItemKey;
                lastDay = unavailableItemKey;
              }

              if (unavailableItemKey + 1 < lastDay) {
                // end of period
                row["unavailable"][week].push(
                  this.getUnavailablePeriodText(firstDay, lastDay)
                );
                // start of new period
                firstDay = unavailableItemKey;
                lastDay = unavailableItemKey;
              }

              lastDay = unavailableItemKey;
            }

            if (firstDay > 0 && lastDay > 0) {
              row["unavailable"][week].push(
                this.getUnavailablePeriodText(firstDay, lastDay)
              );
            }
          }
        }

        data.push(row);
      }

      return data;
    },
    tableDataFiltered: function() {
      var data = [];
      for (var i in this.tableData) {
        if (this.excludeInactive === true && this.tableData[i].deleted === 1) {
          continue;
        }

        data.push(this.tableData[i]);
      }

      return data;
    }
  },
  data() {
    return {
      currentSort: "sort",
      currentSortOrder: "asc",
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["name"],
      tableData: [],
      searchedData: [],
      statuses: [],
      fuseSearch: null,
      timestampNow: 0,
      routes: [],
      report: [],
      loaded: {
        drivers: false,
        routes: false,
        report: false
      },
      excludeInactive: true
    };
  },
  methods: {
    loadDrivers() {
      this.loaded.drivers = false;
      this.$http.get(this.$apiBaseUrl + "drivers/including-inactive").then(
        response => {
          this.tableData = response.data.drivers;

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableDataComputed, {
            keys: ["name", "group", "order"],
            threshold: 0.3
          });

          setTimeout(() => {
            this.loaded.drivers = true;
          }, 500);
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van roosters",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadRoutes() {
      this.loaded.routes = false;
      this.$http.get(this.$apiBaseUrl + "routes").then(
        response => {
          this.routes = response.data.routes;

          setTimeout(() => {
            this.loaded.routes = true;
          }, 500);
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van routes",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadReport() {
      this.loaded.report = false;
      this.$http
        .get(this.$apiBaseUrl + "schedules/report/drivers/scheduled-shifts")
        .then(
          response => {
            this.report = response.data.scheduledPerWeekRoute;

            // setTimeout(() => {
            this.loaded.report = true;
            // }, 100);
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van routes",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    getFullName(data) {
      return (
        data["firstName"] +
        " " +
        (data["lastNamePrefix"] ? data["lastNamePrefix"] + " " : "") +
        data["lastName"]
      );
    },
    getFullNameSort(data) {
      return (
        data["lastName"] +
        " " +
        (data["lastNamePrefix"] ? data["lastNamePrefix"] + " " : "") +
        data["firstName"]
      );
    },
    getStatusLabel(deleted) {
      return deleted == 0 ? "Actief" : "Inactief";
    },
    getStatusColor(deleted) {
      return deleted == 0 ? "#4caf50" : "#f44336";
    },
    getRouteColor(routeId) {
      for (let i in this.routes) {
        if (this.routes[i].id === routeId) {
          return this.routes[i].color;
        }
      }
    },
    allWeeksReverseOrder() {
      if (this.report.length === 0) {
        return [];
      }

      let years = [];
      for (let year in this.report) {
        years.push(year);
      }
      years.reverse();

      let weeks = [];
      for (let year in years) {
        for (let week in this.report[years[year]]) {
          weeks.push(week);
        }
      }
      return weeks.reverse();
    },
    getUnavailablePeriodText(firstDay, lastDay) {
      if (firstDay < 1 || firstDay > 7 || lastDay < 1 || lastDay > 7) {
        return "Error";
      }
      let days = {
        1: "Ma",
        2: "Di",
        3: "Wo",
        4: "Do",
        5: "Vr",
        6: "Za",
        7: "Zo"
      };

      let text = days[firstDay];

      if (firstDay < lastDay) {
        text += "-" + days[lastDay];
      }

      return text;
    },
    handleEditDriver(item) {
      //@todo fix
      this.$router.push("/schedules/edit/" + item.id);
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  created() {},
  mounted() {
    this.loadReport();
    setTimeout(() => {
      this.loadRoutes();
      this.loadDrivers();
    }, 500);
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableDataFiltered;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-card .md-table-cell.cursor-pointer {
  cursor: pointer;
}
ul.legend {
  list-style-type: none;
}
</style>
